import React from 'react';
import {connect} from 'react-redux';

import {AppState} from '../Store';
import {Article} from '../Services/ArticleService';

import ArticleLink from './ArticleLink';

interface ThumbnailProps {
  article: Article;

  getLink: (id: number) => string;
}

function Thumbnail({article, getLink}: ThumbnailProps) {
  return (
    <div className="post-thumbnail">
      <ArticleLink id={article.id}>
        <img src={getLink(article.image)} alt={article.title} />
      </ArticleLink>
    </div>
  );
}

const mapStateToProps = (state: AppState) => {
  return {
    getLink: state.auth.imageService.link,
  };
};

export default connect(mapStateToProps)(Thumbnail);
